const groq = require('groq');
const client = require('../utils/sanityClient.js');

async function getPalettes() {
  const filter = groq`*[_type == "palette"]`;
  const projection = '';
  const order = ``;
  const query = [filter, projection, order].join(' ');
  const docs = await client.fetch(query).catch((err) => console.error(err));
  return docs;
}

module.exports = getPalettes;
